import React from 'react';
import { Menu } from 'antd';
import {
    UserOutlined,
    LogoutOutlined,
    FileTextOutlined,
    ProjectOutlined,
    MedicineBoxOutlined
} from '@ant-design/icons'
import * as Constants from '../../../constants';
import './styles.css';

const MainMenuRegister = ({ onItemClick, itemSelected }) => {
    return (
        <Menu className="MainMenuCont" theme="dark" defaultSelectedKeys={[itemSelected]} mode="horizontal">
            <Menu.Item key={`/`} onClick={() => { onItemClick({ itemClickType: Constants.MenuRegister.USERS }) }}>
                <UserOutlined />
                <span>Usuarios</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuRegister.REGISTERS}`} onClick={() => { onItemClick({ itemClickType: Constants.MenuRegister.REGISTERS }) }}>
                <FileTextOutlined />
                <span>Registros</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuRegister.PROJECTS}`} onClick={() => { onItemClick({ itemClickType: Constants.MenuRegister.PROJECTS }) }}>
                <ProjectOutlined />
                <span>Proyectos</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuRegister.MEDICAL_LICENSES}`} onClick={() => { onItemClick({ itemClickType: Constants.MenuRegister.MEDICAL_LICENSES }) }}>
                <MedicineBoxOutlined />
                <span>Licencias Médicas</span>
            </Menu.Item>
            <Menu.Item key={`/${Constants.MenuRegister.LOGOUT}`} onClick={() => { onItemClick({ itemClickType: Constants.MenuRegister.LOGOUT }) }}>
                <LogoutOutlined />
                <span>Cerrar sesión</span>
            </Menu.Item>
        </Menu>
    );
};

MainMenuRegister.propTypes = {

};

export default MainMenuRegister;

